export const PRODUCT_DISPLAY_PRICE_TYPE = {
	PRICE: 'price',
	INSTALLMENT: 'installment',
};
